import { Order } from '../types'
import { Response } from '../../../services/api/types'
import { axios } from 'lib'
import { useQuery } from 'react-query'
import { toast } from 'react-toastify'

const loadOrderTrackings = (id?: string): Response<Order> => {
  const page = 1
  const limit = 100

  return axios.get(`/orders/${id}/trackings`, {
    params: {
      page,
      limit,
      search: ''
    }
  })
}

export function useLoadOrderTrackings(id?: string) {
  return useQuery(['orderTrackings', id], () => loadOrderTrackings(id), {
    enabled: !!id,
    onError: () =>
      toast.error('Não foi possível carregar os acompanhamentos!', {
        toastId: 'orderTrackings'
      })
  })
}
